import { Injectable } from '@angular/core';
import { PortalBaseService } from 'src/portal/portal-base.service';
import { PortalTaskFormType, PortalTaskModel } from './portal-task.model';
import { lastValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormType } from 'src/app/shared/models/application/formType';

@Injectable({
  providedIn: 'root'
})
export class PortalTasksService extends PortalBaseService {
  public getTasks(): Promise<PortalTaskModel[]> {
    return lastValueFrom(
      this.get<PortalTaskModel[]>('portal/tasks').pipe(
        map((response) =>
          response.map((task) => {
            switch (task.formType) {
              case FormType.Application:
                task.formType = PortalTaskFormType.Form;
                break;
              case FormType.Team:
                task.formType = PortalTaskFormType.TeamForm;
                break;
            }
            return task;
          })
        )
      )
    );
  }
}
